<template>
<div class='steps-wrapper'>
  <div class='step'>
    <div class='content' :class="{'active': step === 'upload'}">
      <div class='icon'>1</div>上传{{$t('common.project')}}
    </div>
    <div class='line'></div>
  </div>
  <div class='step'>
    <div class='content' :class="{'active': step === 'convert'}">
      <div class='icon'>2</div>转化 H5
    </div>
    <div class='line'></div>
  </div>
  <div class='step'>
    <div class='content' :class="{'active': step === 'complete'}">
      <div class='icon'>3</div>分享链接
    </div>
    <div class='line'></div>
  </div>
</div>
</template>

<script>
export default {
  props: ['step']
}
</script>

<style lang='scss' scoped>
// 步骤条
$steps-height: 50px;
$steps_count: 3;
$content_width: 120px;

.steps-wrapper {
    width: 650px;
    height: $steps-height + 2 * 25px;
    padding: 25px 10px;
    margin: 0 auto;

    .step {
        width: percentage(1 / ($steps_count - 1));
        float: left;
        margin-right: - $content_width / ($steps_count - 1);
        position: relative;
        overflow: hidden;

        .content {
            width: $content_width;
            line-height: $steps-height;
            background-color: $color-gray-extreme-light;

            .icon {
                float: left;
                line-height: $steps-height - 2px;
                font-size: $font-size-large;
                font-weight: $font-weight-border;
                color: $color-white-base;
                width: $steps-height;
                height: $steps-height;
                text-align: center;
                background-color: $color-primary-bg-select;
                border-radius: 50%;
                margin-right: 0.4em;
            }

            &.active {
                .icon {
                    color: $color-primary;
                    border: $border-primary;
                    background-color: $color-primary-bg-select;
                }
            }
        }

        .line {
            position: absolute;
            top: 50%;
            left: $content_width + 5px;
            right: 5px + $content_width / ($steps_count - 1);
            height: 1px;
            background-color: $color-gray-light;
        }
        &:last-of-type {
            width: auto;
        }
    }
}
</style>



// WEBPACK FOOTER //
// steps.vue?51ba57b8